import React from 'react';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { Testimonials } from './components/Testimonials';
import { ProblemSection } from './components/ProblemSection';
import { Tomos } from './components/Tomos';
import { Bonos } from './components/Bonos';
import { Countdown } from './components/Countdown';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { Comparison } from './components/Comparison';
import { Footer } from './components/Footer';
import { PurchaseNotification } from './components/PurchaseNotification';
import { MetaPixel } from './components/MetaPixel';
import { Shield, Lock, CreditCard } from 'lucide-react';
export function App() {
  const firstTestimonials = [{
    initials: 'MG',
    quote: 'En 3 días noté la diferencia en el espejo. El diario me mantuvo constante cuando normalmente abandono.',
    name: 'María G.',
    location: 'Córdoba'
  }, {
    initials: 'LP',
    quote: 'El Vacuum por fin lo entendí. Las instrucciones son clarísimas y los resultados se ven rápido.',
    name: 'Laura P.',
    location: 'Rosario'
  }, {
    initials: 'RM',
    quote: 'Nunca pensé que 15 minutos pudieran hacer tanto. Al día 10 la ropa me quedaba diferente.',
    name: 'Roberto M.',
    location: 'Buenos Aires'
  }];
  const secondTestimonials = [{
    initials: 'CR',
    quote: 'El Plan Anti-Sabotaje me cambió la vida. Antes el sábado tiraba todo. Ahora llego al lunes como si nada.',
    name: 'Carla R.',
    location: 'Mendoza'
  }, {
    initials: 'PA',
    quote: 'El Bono de Emergencia lo uso cada vez que me excedo en el asado. En 24 horas vuelvo a estar bien.',
    name: 'Patricia A.',
    location: 'Neuquén'
  }, {
    initials: 'VG',
    quote: 'El Diario de 15 Días es lo que más me ayudó. Soy de las que abandona siempre. Esta vez llegué hasta el final.',
    name: 'Valentina G.',
    location: 'Tucumán'
  }, {
    initials: 'SC',
    quote: 'El Tomo 3 con ingredientes argentinos es oro. Por primera vez seguí un plan sin abandonarlo.',
    name: 'Sofía C.',
    location: 'La Plata'
  }];
  return <div className="min-h-screen bg-brand-dark text-white font-sans selection:bg-brand-green/30" data-id="element-0" data-mp="86499f6lm69i">
      <main data-id="element-1" data-mp="3glwapssg65tf">
        <Hero data-id="element-2" data-mp="3gja5w0wxy4ew" />
        <Stats data-id="element-3" data-mp="3gj1vqgs7dd7e" />
        <Testimonials testimonials={firstTestimonials} columns={3} data-id="element-4" data-mp="3bmjs5k8lzkwn" />
        <ProblemSection data-id="element-5" data-mp="3bk720jsp648i" />
        <Tomos data-id="element-6" data-mp="3qaxsnoijyxa1" />
        <Bonos data-id="element-7" data-mp="3qbfx38fdcht1" />
        <Countdown data-id="element-8" data-mp="3qc93u9ebv7b6" />
        <Pricing sectionId="pricing" data-id="element-9" data-mp="3qcimtd0yge7d" />
        <Testimonials title="❤️ MÁS PERSONAS QUE YA LO TIENEN" testimonials={secondTestimonials} columns={2} data-id="element-10" data-mp="3lkr5lt3ovktw" />
        <Guarantee data-id="element-11" data-mp="2xtbyzo4vqhcu" />
        <FAQ data-id="element-12" data-mp="2xssgo6bbhqya" />
        <Comparison data-id="element-13" data-mp="2xsk64l2o2xq9" />

        {/* Final CTA Section */}
        <div className="pt-10 pb-20" data-id="element-14" data-mp="2sv0pxfmesavo">
          <Pricing title="Empezá hoy. No el próximo lunes." data-id="element-15" data-mp="2stzaz029v48o" />
          <div className="flex flex-col items-center justify-center gap-4 mt-8 text-sm text-gray-400" data-id="element-16" data-mp="18c6o243fvsew">
            <div className="flex flex-wrap justify-center gap-4 md:gap-6" data-id="element-17" data-mp="1d62gkr0xon2o">
              <div className="flex items-center gap-1.5" data-id="element-18" data-mp="ygmuvpg9f7tu">
                <Lock className="w-4 h-4" data-id="element-19" data-mp="13eod685v3349" />
                <span data-id="element-20" data-mp="13fpzj8sbvc1a">Pago 100% seguro</span>
              </div>
              <div className="hidden md:block text-gray-600" data-id="element-21" data-mp="1r4ioumeg2lmx">·</div>
              <div className="flex items-center gap-1.5" data-id="element-22" data-mp="1r2698fw5snd1">
                <span className="text-brand-gold" data-id="element-23" data-mp="1w2aqw98szo4u">⚡</span>
                <span data-id="element-24" data-mp="1i3ku6upwbqh0">Acceso en 5 min</span>
              </div>
              <div className="hidden md:block text-gray-600" data-id="element-25" data-mp="1i319j68v2nza">·</div>
              <div className="flex items-center gap-1.5" data-id="element-26" data-mp="1m4ej9rf2rbbh">
                <Shield className="w-4 h-4" data-id="element-27" data-mp="1m70ohkehteqj" />
                <span data-id="element-28" data-mp="6ncnqi7cfv02">Garantía 7 días</span>
              </div>
            </div>
            <div className="flex items-center gap-2" data-id="element-29" data-mp="aqiqhfv8z41s">
              <CreditCard className="w-4 h-4" data-id="element-30" data-mp="arc2owcz6lrb" />
              <span data-id="element-31" data-mp="qxnnvr6p8oxp">Mercado Pago · Tarjeta · Transferencia</span>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-32" data-mp="m5nez98niloz" />
      <PurchaseNotification data-id="element-33" data-mp="m4ujj4f57im5" />
      <MetaPixel data-id="element-34" data-mp="m4m69bf3ybaf" />
    </div>;
}